import React from "react";
import { FormControlLabel, Radio } from "@mui/material";

const CommonRadio = ({ label, value, checked, onChange, name, disabled, sx, radioSx }) => (
  <FormControlLabel
    value={value}
    control={
      <Radio
        size="small"
        checked={checked}
        onChange={onChange}
        name={name}
        disabled={disabled}
        sx={radioSx}
      />
    }
    label={label}
    sx={sx}
  />
);

export default CommonRadio;
